import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "@/mock/demo/rest.resolver";
import { LabelTeachStatus } from "./model";
// @ts-ignore
const calls: Record<RestCallsKey, MockRestCall> = {
  "custom-labels.analysis": {
    delay: 3000,
    payload: async (payload: { name: string; desc: string; files: File[] }) => {
      console.log("custom-labels.analysis payload: ", payload);
      const { SharedState } = await import("@/common/state");
      return {
        associatedLabels: [SharedState.l0InfoTypes.value[0].id],
        associatedConcepts: [
          "some concept 1",
          "some concept 2",
          "some concept 3",
        ],
        examplesRawBlobKeys: ["blob key 1"],
      };
    },
  },
  "custom-labels.send-created-label-to-teach": {
    delay: 3000,
    payload: async (payload: any) => {
      console.log(
        "custom-labels.send-created-label-to-teach payload: ",
        payload
      );
      return true;
    },
  },
  "label-teach.folder-path-analysis": {
    delay: 3000,
    payload: async (folder_path: string) => {
      if (folder_path === "bad path") {
        return { ok: false, reason: "folder not found" };
      } else {
        return {
          ok: true,
          count: 100,
        };
      }
    },
  },
  "label-teach.label-analysis-status": {
    delay: 2000,
    payload: async (label_id: string): Promise<LabelTeachStatus> => {
      return {
        label_status: "running",
        is_running: label_id == "307852f4-4649-474d-903a-47b93aa62b95",
        created_at: new Date().toISOString(),
        folders: [
          {
            is_running: true,
            num_of_files: 100,
            path:
              "https://cognnipolicies-my.sharepoint.com/personal/user_cognnipolicies_onmicrosoft_com/Documents/Company Secret Files/OneDrive_2022-01-18/2022-Jan-09 - DRAFT 1/Contract Amendments",
          },
          {
            is_running: false,
            num_of_files: 0,
            path: "some/linguistic/path2",
          },
        ],
      };
    },
  },
  "label-teach.send-folder-paths": {
    delay: 3000,
    status: 500,
    payload: async (p: { folders: string[]; label_id: string }) => {
      return true;
    },
  },
};

// @ts-ignore
window.inject_mock_api(calls);
